import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const AnnotateHaug = HelpVideo(
    'Annotate',
    'Editor / Gestures',
    'The Vanishing Pen',
    35020,
    'https://s.ludi.co/app/haug/35020-vanishing-pen.mp4',
);
